export const PortalCarrierPropertiesConsts = {
  CHANGE_NOTICE_DATE_RANGE_MONTH_LIMIT: "CHANGE_NOTICE_DATE_RANGE_MONTH_LIMIT",
  CHANGE_NOTICE_DEFAULT_SOURCE: "CHANGE_NOTICE_DEFAULT_SOURCE",
  RELEASE_NOTES_LINK: "RELEASE_NOTES_LINK",
};
